import { render, staticRenderFns } from "./AccommodationPriceSelect.vue?vue&type=template&id=190c63b8"
import script from "./AccommodationPriceSelect.vue?vue&type=script&lang=ts"
export * from "./AccommodationPriceSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports